import { createSelector } from 'reselect';

import {
  hasPermanentPartnerData,
  hasSelectedIsMarried,
  partnerAge,
  partnerFirstName,
  principalAge,
  principalFirstName,
} from '../PersonalInfoWorkflowSelector';

export const showPartner = createSelector(
  hasPermanentPartnerData,
  hasSelectedIsMarried,
  (partnerPermanentData, isMarriedSelected) => isMarriedSelected || partnerPermanentData,
);

export const principal = createSelector(principalAge, principalFirstName, (age, name) => ({
  FirstName: name,
  Age: age,
}));
export const partner = createSelector(partnerAge, partnerFirstName, (age, name) => ({
  FirstName: name,
  Age: age,
}));
